import React from 'react';
import {
  Container,
  Box,
  CircularProgress,
  Typography,
  Skeleton,
  Paper,
} from '@mui/material';

interface LoadingStateProps {
  projectName?: string;
  type?: 'spinner' | 'skeleton';
}

export const LoadingState: React.FC<LoadingStateProps> = React.memo(({
  projectName,
  type = 'spinner',
}) => {
  if (type === 'skeleton') {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box mb={3}>
          <Skeleton variant="text" width={200} height={40} />
          <Skeleton variant="text" width={300} height={60} />
          <Skeleton variant="text" width={200} height={30} />
        </Box>
        
        <Paper sx={{ p: 2 }}>
          <Skeleton variant="rectangular" height={400} />
        </Paper>
      </Container>
    );
  }
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="400px"
        flexDirection="column"
        gap={2}
      >
        <CircularProgress size={48} thickness={4} />
        <Typography variant="body1" color="text.secondary">
          Loading locations for {projectName || 'project'}...
        </Typography>
      </Box>
    </Container>
  );
});

LoadingState.displayName = 'LoadingState';
